import { ERROR_API_CALL_FAILED } from '../../../common/framework/constants';
import { apiGet, apiPost } from '../../framework/client';
import { CustomerReport } from '../../../common/application/model/report/CustomerReport';
import { CustomerMakesReport } from '../../../common/application/model/report/CustomerMakesReport';
import { BudgetSpentResult } from '../../../common/application/model/BudgetSpentResult';

export const getCustomerFleetReport = async (customerId: string): Promise<CustomerReport> => {
    const response = await apiGet(`/api/customer/${customerId}/report/fleet`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getMultipleCustomerFleetReport = async (
    customerIds: string[],
    year = new Date().getFullYear(),
): Promise<CustomerReport> => {
    const response = await apiPost(`/api/manager/report/fleet`, { customerIds, year });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getCustomerFleetMakeReport = async (customerId: string): Promise<CustomerMakesReport[]> => {
    const response = await apiGet(`/api/customer/${customerId}/report/makes`);
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getMultipleCustomerFleetMakeReport = async (customerIds: string[]): Promise<CustomerMakesReport[]> => {
    const response = await apiPost(`/api/manager/report/makes`, { customerIds });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getCommonGroupName = async (customerIds: string[]): Promise<{ groupName: string | undefined }> => {
    const response = await apiPost(`/api/manager/report/groupName`, { customerId: customerIds });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};

export const getBudgetSpentReport = async (
    customerId: string[],
    month: string[],
    showWithVat: boolean,
): Promise<BudgetSpentResult> => {
    const query = `month IN ({month}) AND customerId IN ({customerId})`;
    const response = await apiPost(`/api/manager/report/budgetSpent`, { customerId, month, query, showWithVat });
    if (response.status === 200) {
        return (await response.json()) as any;
    } else {
        throw new Error(ERROR_API_CALL_FAILED);
    }
};
